import React, { useEffect } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import { nfc1, nfc2, nfc3, nfc4, nfc5, nfc6, nfc7, nfc8, nfc9, nfc10, nfcLogo1, nfcLogo2, nfcLogo3, nfcLogo4 } from '../../assets/images/solution/solutionImages';

import S from './Solution.module.css';

const NfcPage = () => {
  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="solution" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="solution" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div style={{minHeight:'650px'}}>
            <div className='mb-50'>
              <img src={nfc1} alt='nfc' className={`${S.solContentImg} mt-30`} />
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                NFC 인코딩 솔루션
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                NFC 태그에 URL, TEXT, 명함, 연락처 등의 원하는 정보를 간편하게 넣을 수 있으며 <br />
                엑셀연동으로  대량 인코딩 작업도 가능한 솔루션 입니다.
              </div>
              <div className='mt-60 ml-40'>
                <img src={nfc2} id={S.nfcImg2} alt='nfc2' />
              </div>
              <div className={S.nfcContentText}>
                아직도 휴대폰 앱(APP)으로 한 개 씩 인코딩하고 계시나요? <br />
                번거롭고 오래걸리는 방법은 이제 그만! 쉽고 빠르게 <span className={S.redColor}>대량 인코딩</span>
              </div>
              <div className='mt-60'>
                <img src={nfc3} alt='nfc3' className={S.solContentImg}/>
              </div>  
              <div className={`${S.smallContentText} mt-10`}>
                <span className={S.bSmallContentText}>NFC 기능이 탑재되어 있는 스마트폰에서 모두 호환 가능합니다.</span><br />
                홈페이지 접속, 명함, APP을 자유자재로 이용 가능하며 <br />
                대량 인코딩과 TAG복사도 한번에 이용 가능합니다.
              </div>
              <div className='mt-50'>
                <img src={nfc4} alt='nfc4' className={S.solContentImg}/>
              </div>
              <div className={`${S.introText} mt-40`}>
                아직도 휴대폰 앱(APP)으로 한 개 씩 인코딩하고 계시나요? <br />
                번거롭고 오래걸리는 방법은 이제 그만! 쉽고 빠르게 대량 인코딩
              </div>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                NFC 인코딩 솔루션 특별한 기능
              </div>
              <div id={S.nfcImgCardWrapDiv}>
                <img src={nfcLogo1} alt='nfcLogo1' className='mr-50 mt-40'/>
                <img src={nfcLogo2} alt='nfcLogo2' className='mr-50'/>
                <img src={nfcLogo3} alt='nfcLogo3' className='mr-50'/>
                <img src={nfcLogo4} alt='nfcLogo4' />
              </div>
              <div className='mt-50 mb-50'>
                <img src={nfc5} alt='nfc5' className={S.solContentImg}/>
              </div>
              <div className={S.introText}>
                TAG 식별<br />
                Tag 의 칩 정보, 인코딩Data 확인
              </div>
              <div className='mt-50 mb-50'>
                <img src={nfc6} alt='nfc6' className={S.solContentImg}/>
              </div>
              <div className={S.introText}>
                TAG 발행
              </div>
              <div className={S.nfcContentDiv1}>
                <div className='center mt-10'>
                  <img src={nfc7} alt='nfc7' id={S.nfcImg7} />
                </div>
                <div>
                  <ul className={S.nfcUl}>
                    <li>Link : Web페이지 URL링크 연동</li>
                    <li>SMS : 문자 발송</li>
                    <li>Plain text : 텍스트 출력</li>
                    <li>Telephone number : 전화 연결</li>
                    <li>Android Application : 안드로이드 기반 앱 설치/실행</li>
                    <li>Bluetooth : 블루투스 연결/해제</li>
                    <li>Email : 메일 발송</li>
                    <li>Business Card : 연락처 저장</li>
                    <li>Copy Tag : 태그 인코딩data 복사</li>
                  </ul>
                </div>
              </div>
  
              <div className='mt-50 mb-50'>
                <img src={nfc8} alt='nfc8' className={S.solContentImg}/>
              </div>
              <div className={S.introText}>
                Excel 발행<br />
                업로드한 Excel 데이터대로 순차 발행<br />
                변동 데이터 대량 인코딩 시 수월한 작업 가능
              </div>
              <div className='mt-50 mb-50'>
                <img src={nfc9} alt='nfc9' className={S.solContentImg}/>
              </div>
              <div className={S.introText}>
                TAG 잠금<br />
                한 번 인코딩한 태그를 재발행 불가능하도록<br />
                Lock 을 거는 기능
              </div>
              <div className='mt-50 mb-50'>
                <img src={nfc10} alt='nfc10' className={S.solContentImg}/>
              </div>
              <div className={S.introText}>
                발행 카운트<br />
                동일 data 대량 인코딩 시 수량파악 착오를 방지하는 기능<br />
                카운트 완료 시 문구창 팝업
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NfcPage;
